import React from "react";
import { Link } from "react-router-dom";
import { BsLinkedin, BsGithub, BsYoutube, BsInstagram } from "react-icons/bs";
import newsletter from "../images/newsletter.png";

const Footer = () => {
  return (
    <>
      <footer className="py-4">
        <div className="container-xxl">
          <div className="row align-items-center">
            <div className="col-5">
              <div className="footer-top-data d-flex gap-30 align-items-center">
                <img src={newsletter} alt="newsletter" />
                <h2 className="mb-0 text-white">Sign up for newsletter</h2>
              </div>
            </div>
            <div className="col-7">
              <div className="input-group">
                <input
                  type="text"
                  className="form-control py-1"
                  placeholder="Your e-mail address"
                  aria-label="Your e-mail address"
                  aria-describedby="basic-addon2"
                />
                <span className="input-group-text p-3" id="basic-addon2">
                  Subscribe
                </span>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <footer className="py-4">
        <div className="container-xxl">
          <div className="row">
            <div className="col-4">
              <h4 className="text-white mb-4">Contact us</h4>
              <div>
                <address className="text-white fs-6">
                  HSE NO. 404, Teknolojia Valley, <br />
                  NBO, KE <br />
                  PinCode: 86594
                </address>
                <a
                  href="tel +073552222500"
                  className="mt-3 d-block mb-1 text-white"
                >
                  0732594959555
                </a>
                <a
                  href="mailto:patrickmutua719@gmail.com"
                  className="mt-2 d-block mb-0 text-white"
                >
                  patrickmutua719@gmail.com
                </a>
                <div className="social-icons d-flex align-items-center gap-30 mt-4">
                  <a href="www.linkedin.com" className="text-white" to="#">
                    <BsLinkedin className="fs-4" />
                  </a>
                  <a href="www.instagram.com" className="text-white" to="#">
                    <BsInstagram className="fs-4" />
                  </a>
                  <a href="www.github.com" className="text-white" to="#">
                    <BsGithub className="fs-4" />
                  </a>
                  <a href="www.youtube.com" className="text-white" to="#">
                    <BsYoutube className="fs-4" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-3">
              <h4 className="text-white mb-4">Information</h4>
              <div className="footer-link d-flex flex-column">
                <Link to="/privacy-policy" className="text-white py-2 mb-1">
                  Privacy policy
                </Link>
                <Link to="/refund-policy" className="text-white py-2 mb-1">
                  Refund policy
                </Link>
                <Link to="/shipping-policy" className="text-white py-2 mb-1">
                  Shipping policy
                </Link>
                <Link to="/termsandconditions" className="text-white py-2 mb-1">
                  Terms & conditions
                </Link>
                <Link className="text-white py-2 mb-1">Blogs</Link>
              </div>
            </div>
            <div className="col-3">
              <h4 className="text-white mb-4">Account</h4>
              <div className="footer-link d-flex flex-column">
                <Link className="text-white py-2 mb-1">About us</Link>
                <Link className="text-white py-2 mb-1">FAQs</Link>
                <Link className="text-white py-2 mb-1">Contact us</Link>
              </div>
            </div>
            <div className="col-2">
              <h4 className="text-white mb-4">Quick links</h4>
              <div className="footer-link d-flex flex-column">
                <Link className="text-white py-2 mb-1">Laptops</Link>
                <Link className="text-white py-2 mb-1">Headphones</Link>
                <Link className="text-white py-2 mb-1">Tablets</Link>
                <Link className="text-white py-2 mb-1">Watch</Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <footer className="py-4">
        <div className="container-xxl">
          <div className="row">
            <div className="col-12">
              <p className="text-center mb-0 text-white">
                &copy;{new Date().getFullYear()}: Powered by P.M.M
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
